import { render, staticRenderFns } from "./ResolutionAnalytics.vue?vue&type=template&id=5c817128"
import script from "./ResolutionAnalytics.vue?vue&type=script&lang=js"
export * from "./ResolutionAnalytics.vue?vue&type=script&lang=js"
import style0 from "./ResolutionAnalytics.vue?vue&type=style&index=0&id=5c817128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports